// @flow
import { PrintConfActionTypes } from './constants';

const INIT_STATE = {
    printConf: {},
    loading: false,
    error: false,
    formSubmited: false
};

type PrintConfAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { printConf?: {} | null, listaPrintConf?: [] | null, loading?: boolean, +value ?: boolean };

const PrintConf = (state: State = INIT_STATE, action: PrintConfAction): any => {
    // console.log(action);
    switch (action.type) {
        case PrintConfActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PrintConfActionTypes.UPDATE_PRINT_CONF: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }


        case PrintConfActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
               case PrintConfActionTypes.UPDATE_PRINT_CONF: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PrintConfActionTypes.UPDATE_PRINT_CONF:
            return { ...state, error: false, loading: true };
        case PrintConfActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                printConf: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default PrintConf;
